import { NgModule } from '@angular/core';
import { NgxSlideUnlockComponent } from './ngx-slide-unlock.component';
import { FormsModule } from '@angular/forms'
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [NgxSlideUnlockComponent],
  imports: [CommonModule, FormsModule],
  exports: [NgxSlideUnlockComponent]
})
export class NgxSlideUnlockModule {
}
